// extracted by mini-css-extract-plugin
module.exports = {"pg-recover":"styles_pg-recover__2ULGs","cp-layout-loading":"styles_cp-layout-loading__274wR","cp-recover":"styles_cp-recover__1sgJo"};